module.exports = __webpack_public_path__ + "img/icon_map_2_5_yj_hg_c.54bc2c36.png";